module.exports = __webpack_public_path__ + "img/MED_CAKES_AND_PASTRIES@300x.4373301e.png";